<script lang="ts" setup>
import { useGlobalFiltersStore } from "@/shared/stores/useGlobalFiltersStore";
import VButton from "@/shared/ui/common/VButton.vue";
import VDrawer from "@/shared/ui/common/VDrawer.vue";
import VIcon from "@/shared/ui/common/VIcon.vue";
import BrandsFilter from "@/widgets/filters/components/BrandsFilter.vue";
import ChannelsFilter from "@/widgets/filters/components/ChannelsFilter.vue";
import GlobalFilterSidebarHeader from "@/widgets/filters/components/GlobalFilterSidebarHeader.vue";
import ProductFilter from "@/widgets/filters/components/ProductFilter.vue";
import SavedFilters from "@/widgets/filters/components/SavedFilters.vue";

const filtersStore = useGlobalFiltersStore();
const { isFilterVisible } = filtersStore;
</script>

<template>
  <VDrawer
    id="global-filter"
    keep-alive
  >
    <template #header>
      <GlobalFilterSidebarHeader />
    </template>

    <!-- Content -->
    <div class="flex flex-col gap-4 w-full">
      <BrandsFilter v-if="isFilterVisible('brands')" />
      <ChannelsFilter v-if="isFilterVisible('channels')" />
      <ProductFilter v-if="isFilterVisible('products')" />

      <!-- Last Refresh Date -->
      <div
        v-if="filtersStore.refreshDate"
        class="flex items-center gap-2 px-3 py-2.5 rounded-lg
               bg-surface-light border border-border-light"
      >
        <div
          class="flex items-center justify-center w-8 h-8 rounded-md
                 bg-primary-300 text-white"
        >
          <VIcon
            icon="lucide:info"
            size="16"
          />
        </div>
        <div class="flex flex-col flex-1">
          <span class="text-xs font-medium text-secondaryText">Latest Data Refresh</span>
          <span class="text-sm font-semibold text-mainText">{{ filtersStore.refreshDate }}</span>
        </div>
      </div>

      <VButton
        class="w-full"
        icon="lucide:rotate-ccw"
        text="Reset to Default"
        variant="negative"
        @click="filtersStore.resetAllFilters"
      />

      <!-- Saved Filters Section -->
      <SavedFilters />
    </div>
  </VDrawer>
</template>
